import { render, staticRenderFns } from "./UserCommunications.vue?vue&type=template&id=58363e23&scoped=true&"
import script from "./UserCommunications.vue?vue&type=script&lang=js&"
export * from "./UserCommunications.vue?vue&type=script&lang=js&"
import style0 from "./UserCommunications.css?vue&type=style&index=0&id=58363e23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58363e23",
  null
  
)

export default component.exports